import type { ThemePreset } from "../types";

export const ocean: ThemePreset = {
  id: "ocean",
  name: "Ozean",
  nameKey: "admin.settings.appearance.themes.ocean.name",
  description: "Beruhigende Blau- und Türkistöne",
  descriptionKey: "admin.settings.appearance.themes.ocean.description",
  light: {
    background: "oklch(0.985 0.005 220)",
    foreground: "oklch(0.15 0.02 230)",
    card: "oklch(1 0 0)",
    "card-foreground": "oklch(0.15 0.02 230)",
    popover: "oklch(1 0 0)",
    "popover-foreground": "oklch(0.15 0.02 230)",
    primary: "oklch(0.50 0.15 230)",
    "primary-foreground": "oklch(0.985 0 0)",
    secondary: "oklch(0.95 0.02 220)",
    "secondary-foreground": "oklch(0.20 0.02 230)",
    muted: "oklch(0.95 0.015 220)",
    "muted-foreground": "oklch(0.50 0.02 230)",
    accent: "oklch(0.92 0.03 200)",
    "accent-foreground": "oklch(0.20 0.02 230)",
    destructive: "oklch(0.577 0.245 27.325)",
    "destructive-foreground": "oklch(0.985 0 0)",
    border: "oklch(0.90 0.02 220)",
    input: "oklch(0.90 0.02 220)",
    ring: "oklch(0.50 0.15 230)",
    "sidebar-background": "oklch(0.98 0.008 220)",
    "sidebar-foreground": "oklch(0.30 0.02 230)",
    "sidebar-primary": "oklch(0.50 0.15 230)",
    "sidebar-primary-foreground": "oklch(0.985 0 0)",
    "sidebar-accent": "oklch(0.93 0.025 210)",
    "sidebar-accent-foreground": "oklch(0.20 0.02 230)",
    "sidebar-border": "oklch(0.90 0.02 220)",
    "sidebar-ring": "oklch(0.50 0.15 230)",
  },
  dark: {
    background: "oklch(0.17 0.025 230)",
    foreground: "oklch(0.92 0.01 220)",
    card: "oklch(0.20 0.025 230)",
    "card-foreground": "oklch(0.92 0.01 220)",
    popover: "oklch(0.20 0.025 230)",
    "popover-foreground": "oklch(0.92 0.01 220)",
    primary: "oklch(0.65 0.12 210)",
    "primary-foreground": "oklch(0.15 0.02 230)",
    secondary: "oklch(0.25 0.025 230)",
    "secondary-foreground": "oklch(0.90 0.01 220)",
    muted: "oklch(0.25 0.02 230)",
    "muted-foreground": "oklch(0.65 0.02 220)",
    accent: "oklch(0.28 0.03 220)",
    "accent-foreground": "oklch(0.92 0.01 220)",
    destructive: "oklch(0.55 0.22 27)",
    "destructive-foreground": "oklch(0.98 0 0)",
    border: "oklch(0.30 0.025 230)",
    input: "oklch(0.30 0.025 230)",
    ring: "oklch(0.65 0.12 210)",
    "sidebar-background": "oklch(0.14 0.025 230)",
    "sidebar-foreground": "oklch(0.82 0.015 220)",
    "sidebar-primary": "oklch(0.65 0.12 210)",
    "sidebar-primary-foreground": "oklch(0.15 0.02 230)",
    "sidebar-accent": "oklch(0.22 0.025 230)",
    "sidebar-accent-foreground": "oklch(0.92 0.01 220)",
    "sidebar-border": "oklch(0.28 0.025 230)",
    "sidebar-ring": "oklch(0.65 0.12 210)",
  },
};
